import { i18n } from '@apps/main/modules/localization/localizationSetup';

import { TransportType } from '@libs/trip-planner-interfaces';

const { t } = i18n.global;

export function getOwnTransportIcon(
  type: TransportType
): 'car' | 'personBicycling' | 'personWalking' {
  if (type === TransportType.Car) {
    return 'car';
  }
  if (type === TransportType.Bicycle) {
    return 'personBicycling';
  }
  return 'personWalking';
}

export function getOwnTransportDescriptionText(type: TransportType): string {
  if (type === TransportType.Car) {
    return t('planner.transport.car');
  }
  if (type === TransportType.Bicycle) {
    return t('planner.transport.riding_a_bicycle');
  }
  return t('planner.transport.walking');
}
